export const SET_LOADING = 'src/store/admin/SET_LOADING'
export const SET_ADMIN_RESPONSE = 'src/store/admin/SET_ADMIN_RESPONSE'
export const SET_ADMIN_DETAIL = 'src/store/admin/SET_ADMIN_DETAIL'
export const SET_ADMIN_LIST = 'src/store/admin/SET_ADMIN_LIST'
